import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { StoreDeliverySettingYamatoTemplate } from 'components/Templates'

const StoreDeliverySettingYamato: FC = () => {
  return (
    <Layout title={'配送設定'}>
      <StoreDeliverySettingYamatoTemplate />
    </Layout>
  )
}

export default StoreDeliverySettingYamato
